import appRoutes from '@/app/routes.js'
import { loadLanguage } from '@/common/plugins/i18n'
import _ from 'underscore'
import Vue from 'vue'
import Router from 'vue-router'
import commonRoutes from './routes.js'
import toastr from './services/toastr'
import store from './store.js'
import i18n from './plugins/i18n'

Vue.use(Router)

const defaultApplicationTitle = process.env.APP_NAME
const strategy = process.env.AUTH_STORATEGY

const mergeRoutes = function (r1, r2) {
  return _.map(_.uniq(_.union(r1, r2), false, _.property('path')), function (
    route
  ) {
    if (route.meta === undefined) {
      route.meta = {}
    }
    if (route.meta.title === undefined) {
      route.meta.title = defaultApplicationTitle
    }
    if (route.meta.requiresAuth === undefined) {
      route.meta.requiresAuth = false
    }
    if (route.meta.requiresRoles === undefined) {
      route.meta.requiresRoles = []
    }
    if (route.meta.layout === undefined) {
      route.meta.layout = process.env.APP_LAYOUT || 'app-layout-default'
    }
    if (route.meta.theme === undefined) {
      route.meta.theme = process.env.APP_THEME
    }
    if (route.meta.applicationClasses === undefined) {
      route.meta.applicationClasses = []
    }
    return route
  })
}

const router = new Router({
  mode: 'history',
  routes: mergeRoutes(appRoutes, commonRoutes),
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    const selector = location.hash
    return selector ? { selector } : { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  store.dispatch('common/layout/applyLayout', to.meta.layout)
  store.dispatch('common/theme/applyTheme', to.meta.theme)

  if (to.matched.length !== 1) {
    next(new Error('Assertion error. Routing exception.'))
    return
  }

  // 認証が必要でないページは許可。
  const isRequiresAuth = to.matched[0].meta.requiresAuth
  if (!isRequiresAuth) {
    const me = store.getters[`common/${strategy}/me`]
    const language =
      to.params.lang ||
      to.query.lang ||
      (me && me.language) ||
      process.env.APP_LANGUAGE
    loadLanguage(language)
    next()
    return
  }

  // 以下認証が必要。
  // 認証状態をlocalStorageから復元。
  // トークンの更新。
  // メンバー情報をロード。
  store
    .dispatch(`common/${strategy}/refresh`)
    .then(() => {
      const isAuthenticated =
        store.getters[`common/${strategy}/isAuthenticated`]
      // 認証復元に失敗
      if (!isAuthenticated) {
        toastr.info(i18n.t('_account.redirect_for_authorize'))
        sessionStorage.setItem('callback_referrer', to.fullPath)
        // NOTE 低速度回線の場合にjs/cssロード未完了状態でredirectされると
        // メモリキャッシュ扱いになり、ログイン後フォントが正しく表示されない事象回避。
        setTimeout(() => {
          next({ name: `${strategy}_signin` })
        }, 3000)
        return
      }

      // 認可をチェック。
      const requiresRoles = to.matched[0].meta.requiresRoles
      const hasAtLeastOneRole = requiresRoles.some(requiresRole => {
        return store.getters[`common/${strategy}/hasRole`](requiresRole)
      })
      if (!hasAtLeastOneRole) {
        toastr.info(i18n.t('_account.has_no_access'))
        setTimeout(() => {
          next('/')
        }, 1000)
        return
      }

      // ユーザカスタム
      const me = store.getters[`common/${strategy}/me`]
      const language =
        to.params.lang ||
        to.query.lang ||
        (me && me.language) ||
        process.env.APP_LANGUAGE
      const timezone = (me && me.timezone) || process.env.APP_TIMEZONE
      loadLanguage(language, timezone)
      next()
    })
    .catch(error => {
      toastr.info(i18n.t('_account.relogin_message'))
      console.dir(error)
      next({ name: `${strategy}_signin`, query: { _n: new Date().getTime() } })
    })
})

export default router



// WEBPACK FOOTER //
// ./src/common/router.js